import { module } from 'modujs';
import {Recaptcha} from '../utils/captcha';

const CLASS = {
    IS_SUCCESS: 'is-success',
    IS_LOADING: 'is-loading',
    IS_ERROR: 'is-error'
};

export default class extends module {
    /**
     * Class constructor
     *
     * @param m
     */
    constructor(m) {
        super(m);

        this.events ={
            submit: "submit"
        }
    }

    /**
     *
     */
    init() {
        this.confirmMessage = this.getData('confirm-message');
        this.errorMessage = this.getData('error-message');
    }

    /**
     * Set loading state (show loader, fade form, and other UI)
     *
     */
    setLoadingState() {
        this.el.classList.add(CLASS.IS_LOADING)
    }

    /**
     * Set confirmation state;
     * Display confirmation message
     *
     * @param {string} | confirmation message
     */
    setConfirmationState(message) {
        this.clearState();

        this.el.classList.add(CLASS.IS_SUCCESS);
        this.$('feedback')[0].innerHTML = message;

        this.updateScroll();

        setTimeout(() => {
            this.call('scrollTo', [this.$('feedback')[0], -230], 'Scroll', 'main')
        }, 100);
    }

    /**
     * Set error state
     *
     * @param {message} | form error message
     */
    setErrorState(message) {
        this.clearState();

        this.el.classList.add(CLASS.IS_ERROR);
        this.$('feedback')[0].innerHTML = message;

        this.updateScroll();

        setTimeout(() => {
            this.call('scrollTo', [this.$('feedback')[0], -230], 'Scroll', 'main')
        }, 100);
    }

    /**
     * Clear all state
     *
     */
    clearState() {
        this.el.classList.remove(CLASS.IS_SUCCESS);
        this.el.classList.remove(CLASS.IS_LOADING);
        this.el.classList.remove(CLASS.IS_ERROR);

        this.$('feedback')[0].innerHTML = "";

        this.updateScroll();
    }

    /**
     * In case of use of locomotive-scroll, we need to update page height
     *
     * @param {none}
     */
    updateScroll() {
        requestAnimationFrame(() => { this.call('update', null, 'Scroll') });
    }

    /**
     * Custom submit
     *
     * @param {e} | event
     */
    submit(e) {
        e.preventDefault();

        this.clearState();
        this.setLoadingState();


        let isSuccessful = false;

        const form = event.target;
        const action = form.action;

        if (this.formValidates(form)) {

        }

        Recaptcha.execute(() => {
            // Fetch form data here to make sure there's the recaptcha response
            const formData = new FormData(form);
            fetch(action, {
                method: form.method,
                body:   formData,
            }).then(response => {
                if (response.status >= 200 && response.status <= 299) {
                    isSuccessful = true;
                }

                return response.json()
            }).then(response => {
                isSuccessful = isSuccessful && response.success;

                if (isSuccessful) {
                    this.setConfirmationState(this.confirmMessage);
                } else if (response.success === false && response.feedback) {
                    let errorMessage = [];
                    for (var k in response.feedback) {
                        errorMessage.push(response.feedback[k]);
                    }
                    console.log(errorMessage);
                    this.setErrorState(this.errorMessage + '<span>' + errorMessage.join('<br/>') +'</span>');
                } else {
                    this.setErrorState(this.errorMessage);
                }

            }).catch(error => {
                // An error occured
                this.setErrorState(this.errorMessage);
            })
        });
    }

    formValidates(form) {
        let requiredFields = form.querySelectorAll('.js-required');

        let success = true;

        // requiredFields.forEach((e) => {
        //     console.log(e.value);
        //     console.log(e.tagName);
        //     if (typeof e.value === 'undefined') {
        //         success = false;
        //     }
        // });

        return success;
    }
}
